
import React from 'react';
import { Theme } from '../types';
import { HELP_MODAL_CONTENT } from '../constants';
import { CloseIcon } from './icons';

interface HelpModalProps {
  isOpen: boolean;
  onClose: () => void;
  theme: Theme;
}

const HelpModal: React.FC<HelpModalProps> = ({ isOpen, onClose, theme }) => {
  if (!isOpen) return null;

  const modalBg = theme === 'dark' ? 'bg-hba-mid-purple' : 'bg-white';
  const textColor = theme === 'dark' ? 'text-hba-text-primary' : 'text-gray-800';
  const secondaryTextColor = theme === 'dark' ? 'text-hba-text-secondary' : 'text-gray-600';
  const titleColor = theme === 'dark' ? 'text-hba-accent-pink' : 'text-hba-accent-purple';

  return (
    <div className="fixed inset-0 bg-black bg-opacity-75 flex items-center justify-center p-4 z-50 transition-opacity duration-300 ease-in-out">
      <div className={`${modalBg} rounded-lg shadow-xl p-6 w-full max-w-lg max-h-[80vh] overflow-y-auto`}>
        <div className="flex justify-between items-center mb-4">
          <h2 className={`text-2xl font-bold ${titleColor}`}>Indicaciones / Ayuda</h2>
          <button onClick={onClose} className={`p-1 rounded-full ${theme === 'dark' ? 'text-hba-text-secondary hover:text-hba-text-primary hover:bg-hba-light-purple' : 'text-gray-500 hover:text-gray-800 hover:bg-gray-200'}`}>
            <CloseIcon className="w-6 h-6" />
          </button>
        </div>
        <div className="space-y-4">
          {HELP_MODAL_CONTENT.map((item, index) => (
            <div key={index}>
              <h3 className={`text-lg font-semibold ${titleColor}`}>{item.title}</h3>
              <p className={`text-sm whitespace-pre-line ${secondaryTextColor}`}>{item.text}</p>
            </div>
          ))}
        </div>
        <div className="mt-6 text-right">
          <button
            onClick={onClose}
            className={`py-2 px-4 rounded-md font-semibold transition-colors focus:outline-none focus:ring-2 focus:ring-opacity-50 ${theme === 'dark' ? 'bg-hba-accent-pink text-white hover:bg-pink-700 focus:ring-hba-accent-pink' : 'bg-hba-accent-purple text-white hover:bg-purple-700 focus:ring-hba-accent-purple'}`}
          >
            Entendido
          </button>
        </div>
      </div>
    </div>
  );
};

export default HelpModal;
